export default __webpack_public_path__ + "static/media/coding.5fb4df1f.png";